import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { SessionService } from "./session.service";

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  public static readonly NEVER_GRANTED_POLICY_ID = 'bbe44b2d-8f0a-4657-8d48-c1b28e6c81e8';
  public static readonly LOGGED_IN_USER_POLICY_ID = '65dc6df8-109c-4dbc-b6f3-d85ee0bb6b6e';

  private apiUrl: string = "";
  private getPolicyIdsPromise: Promise<string[]> | null = null;
  private currentUserId: string = '';

  constructor(
    private http: HttpClient,
    private constantsService: ConstantsService,
    private sessionService: SessionService,
  ) {
  }

  getPolicyIds(): Promise<string[]> {
    if (this.sessionService.getValue('user_id') != this.currentUserId || this.getPolicyIdsPromise === null) {
      this.currentUserId = this.sessionService.getValue('user_id');

      this.getPolicyIdsPromise = new Promise<string[]>((resolve, reject) => {
        this.constantsService.onReady(() => {
          this.apiUrl = this.constantsService.getConstant('apiUrl');

          this.http.get<string[]>(this.apiUrl + '/user/api/v1/policies/user-policy-ids', { withCredentials: true }).subscribe({
            next: (userPolicies) => {
              const policies = userPolicies || [];

              if (!policies.includes(PolicyService.LOGGED_IN_USER_POLICY_ID)) {
                policies.push(PolicyService.LOGGED_IN_USER_POLICY_ID);
              }

              resolve(policies);
            },
            error: (error) => {
              this.getPolicyIdsPromise = null;
              reject(error);
            }
          });
        })
      });
    }

    return this.getPolicyIdsPromise;
  }

  getPolicyId(policyKey: string): string {
    if (!policyKey || policyKey.trim().length === 0) {
      return PolicyService.NEVER_GRANTED_POLICY_ID;
    }

    if (this.constantsService.hasConstant(policyKey)) {
      return this.constantsService.getConstant(policyKey);
    }

    console.warn(`Policy key "${policyKey}" not found in constants.`);

    if (isDevMode()) {
      return PolicyService.LOGGED_IN_USER_POLICY_ID;
    }

    return PolicyService.NEVER_GRANTED_POLICY_ID;
  }

  isPolicyId(policyKey: string): boolean {
    return this.isUuid(policyKey);
  }

  private isUuid(value: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    return uuidRegex.test(value);
  }
}
